/**
 * AdSlot — house-ad banner shown only to Free tier users.
 * If REACT_APP_ADSENSE_PUBLISHER_ID is set, mounts an actual AdSense script.
 * Otherwise renders a "house ad" — a styled upgrade CTA — so the slot never breaks.
 */
import { useEffect } from "react";

const PUBLISHER_ID = process.env.REACT_APP_ADSENSE_PUBLISHER_ID;

export default function AdSlot({ tier, slot = "trader-sidebar" }) {
  const hidden = tier && tier !== "free";

  useEffect(() => {
    if (hidden || !PUBLISHER_ID) return;
    // Load AdSense library once
    if (!document.querySelector('script[data-ads-loaded]')) {
      const s = document.createElement("script");
      s.async = true;
      s.crossOrigin = "anonymous";
      s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-${PUBLISHER_ID}`;
      s.setAttribute("data-ads-loaded", "1");
      document.head.appendChild(s);
    }
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch {}
  }, [hidden]);

  if (hidden) return null;

  if (PUBLISHER_ID) {
    return (
      <div data-testid="adsense-slot" data-slot={slot} className="my-2">
        <ins className="adsbygoogle block"
          style={{ display: "block" }}
          data-ad-client={`ca-pub-${PUBLISHER_ID}`}
          data-ad-slot={slot}
          data-ad-format="auto"
          data-full-width-responsive="true"/>
      </div>
    );
  }

  // House ad fallback
  return (
    <a href="/account?tab=plan" data-testid="house-ad" data-slot={slot}
      className="block my-2 p-3 rounded-lg bg-gradient-to-r from-amber-500/15 via-orange-500/15 to-rose-500/15 border border-amber-500/30 hover:border-amber-400 transition-all font-mono">
      <div className="flex items-center gap-3">
        <div className="text-amber-400 text-2xl"><i className="fa-solid fa-crown"/></div>
        <div className="flex-1">
          <div className="text-[10px] text-amber-300 uppercase tracking-widest font-bold">Free plan · Ad</div>
          <div className="text-xs text-white font-bold">Go Pro · unlock 60-day replay + unlimited AI reviews</div>
          <div className="text-[10px] text-slate-400">No ads. All symbols. Daily, weekly & yearly leaderboards.</div>
        </div>
        <div className="text-amber-300 font-bold text-xs">$19/mo →</div>
      </div>
    </a>
  );
}
